function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1.16734431,2.46529631 L2.65144893,0.981191699 L7.58985232,5.91959509 L6.10574771,7.40369971 L1.16734431,2.46529631 Z M8.92769251,10.2256445 L10.4117971,8.74153989 L13.4030586,11.7328014 L11.918954,13.216906 L8.92769251,10.2256445 Z M12.6263032,13.9242552 L14.1104078,12.4401505 L14.7793279,14.5931752 L12.6263032,13.9242552 Z M14.7793279,1.723244 C15.2740294,2.21794554 12.4078344,5.57884207 6.18074289,11.8059336 L4.69663828,10.321829 C10.9237298,4.09473746 14.2846263,1.22854247 14.7793279,1.723244 Z M4.73134142,11.7712305 C4.23663988,11.2765289 4.22445118,10.7940161 4.69477531,10.3236919 L6.17887992,11.8077966 C5.70855579,12.2781207 5.22604295,12.265932 4.73134142,11.7712305 Z M1.4919922,14.1757708 C2.82849111,13.3958111 2.27195188,12.8392719 2.80106653,12.3101573 C3.33018118,11.7810426 3.33018118,11.7810426 3.88672041,12.3375818 C4.3477726,12.798634 4.72152925,13.1723907 4.1924146,13.7015053 C3.66329996,14.23062 2.85591569,14.481465 1.4919922,14.1757708 Z"
});

var SvgStyle = function SvgStyle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStyle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Style.65dbc7a6.svg";
export { ForwardRef as ReactComponent };